import React, {useMemo} from "react";
import {Activity} from "../../../types";
import {ActivityTypeNames} from "../../../constants";
import {BookOutlined, CheckCircleOutlined} from "@ant-design/icons";
import {SubtitleItemProps} from "../../../components/PageHeader";
import { isNumber } from "lodash";
import { useLabels } from "../../../hooks/Labels";

export const useActivitySubtitle = (activity?: Activity) => {
    const {t} = useLabels();
    return useMemo(() => {
        if (!activity) return undefined;
        const items: SubtitleItemProps[] = [];
        if (activity.course) {
            items.push({
                title: activity.course.title,
                icon: <BookOutlined/>
            });
        }
        if (isNumber(activity.pass_threshold)) {
            items.push({
                title: activity.pass_threshold === 0 ? t('pass_threshold_zero') : `${t('pass_threshold')}: ${activity.pass_threshold}%`,
                tootltip: activity.pass_threshold === 0 ? t('pass_threshold_zero_tooltip') : t('pass_threshold_tooltip'),
                icon: <CheckCircleOutlined/>
            })
        }
        items.push({
            title: activity.renderers.length > 0 ?
                activity.renderers.map(renderer => renderer.name).join(', ') :
                ActivityTypeNames[activity.type]
        })
        if (activity.primary_attribute) {
            items.push({
                title: activity.primary_attribute.value
            })
        }
        return items;
    }, [activity]);
}